import {IResourceItem, userFriendlyResourceName, useTranslate} from '@refinedev/core';

import {safeTranslate} from '@providers/document-title/safe-translate';
const APP_ENV = import.meta.env.VITE_APP_ENV.toUpperCase();

export function generateDocumentTitle(
  translate: ReturnType<typeof useTranslate>,
  resource?: IResourceItem,
  action?: string,
  id?: string,
  resourceName?: string,
) {
  const actionPrefix = resource?.meta?.prefix ?? resource?.name;

  const identifier = resource?.identifier ?? resource?.name;

  const resourceNameFallback =
    resource?.label ??
    resource?.meta?.label ??
    userFriendlyResourceName(identifier, action === 'list' ? 'plural' : 'singular');

  const resourceNameWithFallback = resourceName ?? resourceNameFallback;

  const defaultTitle = safeTranslate(translate, 'documentTitle.default', 'Refine');
  const suffix = safeTranslate(translate, 'documentTitle.suffix', ' | Refine');

  let autoGeneratedTitle = defaultTitle;
  if (action && identifier) {
    autoGeneratedTitle =
      safeTranslate(translate, `${actionPrefix}.titles.${action}`, `${resourceNameWithFallback}${suffix}`, {id}) +
      suffix;
  }

  if (autoGeneratedTitle) {
    autoGeneratedTitle = `${APP_ENV !== 'PROD' ? `🚧` : ''} ${autoGeneratedTitle}`;
  }

  return autoGeneratedTitle;
}
